export const en = {
  header: {
    support: 'Talk to Support',
    contact: 'Contact Us',
    dialogs: {
      notification: {
        heading: 'Notifications',
        action: 'Mark all as read',
        empty: 'Nothing pending :)',
        message: {
          heading: 'Chroma Training',
          text: 'Free live training now available for all Chroma tiers',
          link: 'Schedule your training',
        },
      },
      user: {
        settings: 'Account settings',
        logout: 'Logout',
      },
    },
  },
  footer: {
    terms: 'Terms of Service',
    policy: 'Privacy Policy',
  },
  nav: {
    dashboard: 'Dashboard',
    products: 'My Products',
    preTraining: 'Pre-Training',
    postTraining: 'Post-Training',
    schedule: 'Training Schedule',
    orders: 'My Orders',
    transactions: 'Transaction History',
    referrals: 'Referral Rewards',
  },
  dashboard: {
    events: {
      heading: 'Events',
      table: {
        h1: 'ticket',
        h2: 'discount code',
        h3: 'status',
      },
    },
    products: {
      heading: 'My Products',
      action: 'view all',
      link: 'Start Pre-Training',
    },
    orders: {
      heading: 'My Orders',
      action: 'view all',
    },
    referrals: {
      heading: 'Referral Rewards',
      action: 'view all',
      message: "People I've Referred",
    },
    facebook: {
      title: 'Become a member of the Ricoma Users Official group on Facebook',
      content:
        'You can now join a private elite group of custom apparel decorators on Facebook. This exclusive community is filled with professionals and hobbyists who are masters of their crafts. By joining, you’ll gain access to this supportive network where you can ask questions, share projects, exchange decorating tips, and so much more.',
      link: 'JOIN NOW',
    },
    decosummit: {
      title: 'SAVE 20% OFF WITH CODE',
      content: 'Use your discount code above to save 20% OFF DecoSummit 2024 tickets!',
      link: 'Get your ticket now',
    },
    giftcards: {
      title: 'GIFT CARD BALANCE',
      view: 'view details',
      text: 'To redeem your gift card, simply enter the code at checkout on',
    },
    ad: {
      link: 'Buy Now',
    },
    salesRep: {
      heading: 'My Sales Rep',
    },
  },
  products: {
    heading: 'My Products',
  },
  product: {
    link: 'Start Pre-Training',
    chroma_link: 'Download Now',
  },
  productDetails: {
    header: {
      heading: 'My Products',
    },
    pendingSubscriptionsLegacy: {
      heading: 'Licenses available for subscription upgrade',
    },
    pendingSubscriptions: {
      heading: 'Licenses pending activation',
    },
    resources: {
      heading: 'Resources',
      download: 'Download',
      watch: 'Watch Training Videos',
    },
    videos: {
      heading: 'Training Videos',
      heading_chroma: 'Training Videos',
      action1: 'view all',
      action2: 'compact view',
    },
    normal_videos: {
      heading: 'Videos',
      action1: 'view all',
      action2: 'compact view',
    },
    accessories: {
      heading: 'Maximize Your Investment',
      link: 'Buy Now',
    },
    card: {
      machines: {
        serial: 'Serial Number',
        date: 'Ordered',
        text: 'Pre-training is now available for your {machine}.',
        link: 'Start Pre-training',
      },
      chroma: {
        serial: 'Serial Number',
        tier: 'Tier',
        date: 'Ordered',
        action: 'Actions',
        text: 'Upgrade from {chroma1} to {chroma2}',
        link: 'MANAGE SUBSCRIPTIONS',
        note: 'Want to make changes to your account?',
        upgrade: 'UPGRADE',
        active: 'ACTIVE',
        manage: 'MANAGE',
      },
      chroma_legacy: {
        serial: 'Serial Number',
        tier: 'Tier',
        date: 'Ordered',
        action: 'Actions',
        text: 'Upgrade from {chroma1} to {chroma2}',
        link: 'WHAT’S NEW',
        note:
          '<p class="mb-1 text-left" style="color: #F17D21;font-size: 12px">UPGRADE AVAILABLE</p><p class="mb-1 text-left" style="font-weight: 700;font-size: 16px; ">Save up to $2,000 by upgrading your Chroma legacy license to a subscription</p><p class="mb-2 text-left">Enjoy unlimited feature updates, 97+ new fonts, texture backgrounds, enhanced realistic views, and more based on the plan selected. Learn all the new features a Chroma subscription has to offer.</p>',
        upgrade: 'UPGRADE',
        active: 'ACTIVATE',
        manage: 'MANAGE',
      },
      chroma_promo: {
        note: 'Free Trial Available',
        title: 'Experience all Chroma Luxe features free for 14 days!',
        content:
          "Are you ready to take your digitizing skills to the next level? Start your 14-day free trial with Chroma to explore Luxe's advanced digitizing tools, including 250+ pre-digitized fonts, 3D models, and much more<b >—no obligation, no credit card required.</b>",
        button: 'TRY FREE FOR 14 DAYS →',
      },
    },
  },
  preTraining: {
    heading: 'Pre-Training',
    subheading: 'Choose your machine',
    continueBtn: 'Continue Pre-Training',
    startBtn: 'Start Pre-Training',
    takeQuizBtn: 'Take Quiz',
    takeNoQuizBtn: 'Next',
    submitQuiz: 'Submit Quiz',
    scheduleBtn: 'Schedule Training',
    noPretrainingAvailable: 'No Pre-Training available for preferred language',
    video: {
      heading: 'Video is complete',
      subheadingStart: 'Select "Start Pretraining" to continue.',
      subheadingContinue: 'Select "Continue PreTraining" to continue.',
      subheadingSchedule: 'Select "Schedule Training" to continue.',
      subheadingQuiz: 'Select "Take Quiz" to continue.',
      replayBtn: 'Replay Video',
    },
    intro: {
      listHeading: "What you'll cover in this pre-training",
      listPrefix: 'Lesson {number}: ',
    },
    lesson: {
      heading: 'Lesson {number}: ',
      resources: 'Resources',
    },
    checklist: {
      title: 'Pre-Training Checklist',
    },
    warning: {
      title: 'PLEASE READ AND ACKNOWLEDGE',
      content:
        'Customers are responsible for completing this pre-training prior to their 10 hours of onsite tech training. If not completed, the time the technician spends on pre-training will cut into the required 10 hours of onsite training. Customers will not be able to make up this time during or after onsite training. <b >Failure to complete pre-training and all 10 hours of onsite training will void the warranty.</b >',
      checkbox: 'I acknowledge this and am ready to start the pre-training.',
      button: 'Begin pre-training',
    },
    vision: {
      warning: {
        title: 'PLEASE READ AND ACKNOWLEDGE',
        content:
          'Do not Power on or Operate the Machine Prior to Online Training. Failure to do so will result in possible damages to the machine and voiding of warranty.<br><br>If you can any questions please contact us at: <a href="mailto:service@ricoma.com">service@ricoma.com</a>',
        checkbox: 'I acknowledge this and am ready to start the pre-training.',
        button: 'Begin pre-training',
      },
    },
    thank_you: {
      content: {
        'p-1':
          "Thank you! We're thrilled to begin scheduling your training. You should have an email from us outlining the next steps to book your online training session.",
        'p-2':
          "Haven't seen our email? No worries! Just <a href='https://support.ricoma.com/hc/en-us' target='_blank'>click here</a> to create a support ticket, and we'll be in touch to ensure you're all set.",
        'p-3': 'Welcome aboard – your training adventure begins now!',
      },
      button: 'close',
      content_warning: {
        'p-1':
          'We sent you an email regarding the activation of your training. To ensure a smooth start, please follow the steps outlined in the email.',
        'p-2':
          "Haven't seen our email? No worries! Just <a href='https://support.ricoma.com/hc/en-us' target='_blank' class='text-blue-500'>click here</a> to create a support ticket, and we'll be in touch to ensure you're all set.",
      },
    },
  },
  postTraining: {
    heading: 'Post-Training',
    subheading: 'Select a machine to access your post training resources.',
    link: 'Watch Post-Training Videos',
    dtg: {
      heat_press: 'Heat Press Settings',
      pre_treated: 'Pre-Treated Shirts',
      warranty: {
        heading: 'Ri 1000/2000 Post Training Resources',
        subheading: 'Warranty Specific Need To Know',
        card: {
          heading: 'Before you can access your Ri 1000/2000 resources...',
          text:
            'Please read through the warranty info below and confirm that you’ve read and understand.',
        },
        button: 'I’ve read and Understand',
        pdf: 'Download PDF',
        list: {
          't-1':
            '<b>NEVER MOVE YOUR PRINTER WITHOUT FOLLOWING PROPER PROCEDURE FOR STORAGE, SHIPPING OR MOVING, AFTER INK CARTRIDGES HAVE BEEN INSTALLED. IF YOU ARE UNSURE HOW TO DO THIS PLEASE CONTACT SUPPORT.</b>',
          't-2':
            '<b>DO NOT TURN YOUR Printer OFF for ANY Reason, Unless it is filled with cleaner and capped.</b>',
          't-3':
            '<b>Always leave your printer on to allow the machine’s automated maintenance sequences to run.</b> This is necessary to keep the printer in optimal condition and avoid the potential damage that can be prevented easily. <b>If it is necessary to power down the machine for over 12 hours, be sure to fill your printer with cleaning fluid.</b> Refer to Section 8.3 of your User Manual for more information.',
          't-4':
            '<b>White Cartridge should also be taken out of the machine and shaken daily as prompted  to avoid clogging of the white lines.</b> Always shake new white ink cartridges thoroughly before installing them in your printer. Adequately shaking your new white ink cartridges helps ensure that your prints will come out bright and vibrant. Refer to the User Manual, page 18, for more information.',
          't-5':
            '<b>Perform a nozzle check daily,</b> so you can spot and quickly address potential issues with the printer. Nozzle checks not done daily will void your Warranty. Daily Printing Does not equal a Nozzle check!',
          't-6':
            '<b>Environment specifics- Humidity Requirement</b> between 45% to 80% on the display, not using outside meters, <b>Temperature  Requirement</b> 61°F to 90°F not using outside meters. It is crucial for trouble-free printer operation that the Relative Humidity (RH) requirement is met at all times when the printer is loaded with ink. If the environment is below the specified Relative Humidity the ink will dry more quickly at the Print Head causing nozzles to become clogged.  If relative humidity falls below 45% at any time, it will be necessary to use a high-powered non-misting humidifier to increase the humidity in the immediate area of the printer. Also keep in mind that it will be much easier to control the environment in a small area rather than a large one.',
          't-7':
            '<b>Make sure your ink or cleaning cartridges are at 5% or above when you are done printing for the day or plan on leaving your printer idle for a few hours.</b> While you can continue to print using cartridges with less than 5% remaining, the machine’s vital automated maintenance sequences require at least 5% or above in order to complete. If you do not have replacement ink available, you can fill your printer with cleaning fluid. Refer to Section 8.3 of your User Manual.',
          't-8':
            '<b>Clean encoder strip weekly or every 30 prints to help avoid blurry prints, double prints, and error codes.</b> Refer to Section 8.2 of your User Manual or watch the Ricoh DTG University: Ri 1000/2000 Weekly Maintenance Video.',
          't-9':
            '<b>Make sure the obstacle sensor is on.</b> If the sensor is off, head strikes may occur and cause damage to the carriage. To check if your obstacle sensor is enabled, navigate to the OPTIONS panel. The sensor is on when the blue light is illuminated on the OBSTACLE SENSOR button.',
          't-10':
            '<b>Set the Platen height correctly — just below the obstruction sensor.</b> If the Platen is too low, the extra space may cause misting and printer damage. If the garment is dressed on the platen, the number on the Platen height adjuster should be between 0-2. If not dressing the garment, the number value should be no more than 4. Refer to Section 2.2 of your User Manual. Improper Platen Height can cause misting of ink inside the Printer and will void the Warranty if it is determined caused by improper Platen Height.',
          't-11':
            '<b>Exercise care when adjusting Platen height or changing platens.</b> While ruggedly constructed, the Ri 1000/2000 is a precision tool, and care should be taken when making adjustments to the machine. Do NOT over-tighten the table-height-adjustment knob past “0” and carefully install platen without banging it against the print table.',
          't-12':
            '<b>Make sure to complete DAILY, WEEKLY and Monthly Maintenance, if determined they are not done, the Warranty will be voided.</b>',
          't-13':
            '<b>Fan Filters must be replaced, when the warning comes up, if it is determined they are not changed, the Warranty will be voided.</b>',
          't-14':
            '<b>Stay updated!</b> Visit the Downloads page to access important updates to your firmware, User Manual, and AnaRIP.',
        },
      },
    },
    resources: {
      heading: 'Post Training Resources',
      downloads: 'Downloads',
      download: 'Download',
      videos: 'Training Videos',
    },
  },
  schedule: {
    header: 'Training Schedule',
    heading: 'Schedule or cancel live trainings',
    subheading: 'Here you can view, schedule, cancel, or reschedule your trainings.',
    list: {
      table: {
        ths: {
          th1: 'Important Note*',
          th2: 'Date',
          th3: 'time',
          th4: 'Machine',
          th5: 'Topic',
          th6: 'Type',
          th7: 'Link',
          th8: 'Edit',
        },
        btn: 'Cancel Training',
      },
      btn: 'Schedule new training',
      noTrainings: 'You have no trainings scheduled at this time.',
    },
    modalNew: {
      heading: 'Schedule new training',
      form: {
        fields: {
          f1: {
            label: 'Choose your machine*',
            placeholder: 'Please choose a machine',
          },
          f2: {
            label: 'Phone Number*',
            placeholder: 'e.g. +1 222 333 4444  or  222 333 4444',
          },
          f3: {
            label: 'Choose a type of training*',
            placeholder: 'Please choose a type of training',
          },
          f4: {
            label: 'Choose a language*',
            placeholder: 'Please choose a preferred language',
          },
          f5: {
            label: 'Choose a date & time*',
            placeholder: 'Please choose a date & time ( EASTERN TIME )',
          },
        },
        btn: 'Next',
      },
    },
    modalCancel: {
      heading: 'Cancel Schedule Training',
      box: {
        lines: {
          l1: 'Your {machine} series online training on',
          l2: 'will be canceled.',
        },
      },
      btn: 'Cancel my training',
    },
    modalConfirm: {
      heading: 'Schedule New Training',
      box: {
        lines: {
          l1: 'Your online training date & time is set for',
        },
      },
      additionalText:
        'Click below to schedule your training. We’ll email you further instructions. We look forward to seeing you!',
      btn: 'Confirm my training!',
    },
    modalConfirmCancelShedule: {
      box: {
        lines: {
          l1: 'Your online training date & time is set for',
        },
      },
      additionalText: 'Are you sure you do not want to confirm the training ?',
      btn: 'Do not confirm my training!',
    },
    videoRecords: {
      heading: 'Past recordings',
      noData: 'Nothing to show.',
      list: {
        table: {
          ths: {
            th1: 'Date',
            th2: 'time',
            th3: 'Machine',
            th4: 'Topic',
            th5: 'Link',
          },
          btn: 'Watch',
        },
      },
    },
  },
  orders: {
    header: {
      heading: 'Current Orders',
    },
  },
  order: {
    heading: 'Order# {number}',
    date: 'Ordered on {date}',
  },
  orderFulfillment: {
    header: {
      heading: 'Fulfillment # {number}',
      tracking: 'Tracking # {number}',
    },
    tabOrders: {
      ordered: 'Ordered',
      picked: 'Picked',
      packed: 'Packed',
      shipped: 'Shipped',
    },
    estimatesTimeDelivery: {
      single: {
        constant: 'This item',
        shipped: 'was shipped on',
        noShipped: 'is expected to ship on',
      },
      multiple: {
        constant: 'These items',
        shipped: 'were shipped on',
        noShipped: 'are expected to ship on',
      },
    },
    dropdown: {
      btn: 'Hide Items',
      table: {
        ths: {
          th1: 'Item',
          th2: 'description',
          th3: 'quantity',
        },
      },
    },
  },
  referrals: {
    header: {
      heading: 'Referral Rewards',
    },
    intro: {
      heading: {
        general: 'Refer a Friend and Earn Credits',
        influencer: 'Refer a Friend and Earn Rewards',
      },
      howItWorks: {
        heading: 'How it works',
        actionText: 'click here to watch',
        list: {
          'l1-general':
            'Below are three unique referral links to promote our embroidery machines and printers. There is also a link to promote products sold on our online store at shop.ricoma.com.',
          'l1-influencer':
            'Below are three unique referral links to promote our embroidery machines and printers. There is also a link to promote products sold on our online store at shop.ricoma.com.',
          'l2-general':
            'Each machine link contains a special promotion that can be applied by the sales rep if it is used to contact us.',
          'l2-influencer':
            'Each machine link contains a special promotion that can be applied by the sales rep if it is used to contact us.',
          'l3-general':
            'Upon a purchase made through any of the provided links, you will earn a credit to your account, which can be utilized for future purchases from Ricoma.',
          'l3-influencer':
            'Upon a purchase made through any of the links you provided, you will receive rewards to your account.',
        },
      },
    },
    social_customer_portal: {
      heading: 'Your embroidery machine referral link:',
      btn: 'copy link',
    },
    social_dtp_portal: {
      heading: 'Your Luminaris 200 referral link:',
      btn: 'copy link',
    },
    social_dtf_portal: {
      heading: 'Your DTF referral link:',
      btn: 'copy link',
    },
    social_chroma_portal: {
      heading: 'Your Chroma referral link:',
      btn: 'copy link',
    },
    social_dtg_portal: {
      heading: 'Your DTG referral link:',
      btn: 'copy link',
    },
    social_shop_ricoma: {
      heading: 'Your shop.ricoma.com referral link:',
      btn: 'copy link',
      modal_btn: 'View products eligible for rewards',
      modal_text: 'shop.ricoma.com - Products Eligible for Rewards',
    },
    stats: {
      blocks: {
        b1: {
          'title-general': 'Available Ricoma Credits',
          'title-influencer': 'Available Ricoma Rewards',
          subtitle:
            'Funds temporarily disabled until pending payouts balance is greater than $0.00.',
          'content-general-1': '',
          'content-general-2': '',
          'content-influencer-1': '',
          'content-influencer-2': '',
          tooltip: '',
        },
        b2: {
          'title-general': 'Pending Ricoma Credits',
          'title-influencer': 'Pending Ricoma Rewards',
          subtitle: '',
          'content-general-1': '',
          'content-general-2': '',
          'content-influencer-1': '',
          'content-influencer-2': '',
          tooltip:
            "This is your current rewards balance. This balance reflects the total amount you've earned based on your referral percentage. This amount may appear negative if a customer chooses to return their order or part of their order. You will not have to pay a negative balance. Simply refer another friend to continue receiving your rewards.",
        },
        b3: {
          'title-general': '',
          'title-influencer': '',
          subtitle: '',
          'content-general-1': 'Total Orders Referred To-Date:',
          'content-general-2': 'Total Ricoma Referral Credits Earned To-Date:',
          'content-influencer-1': 'Total Orders Referred To-Date:',
          'content-influencer-2': 'Total Ricoma Referral Rewards Earned To-Date:',
          tooltip: '',
        },
      },
      table: {
        heading: 'Referral History',
        ths: {
          th1: 'invoice/memo #',
          th2: 'Sales Order #',
          th3: 'date',
          th4: 'referral threshold',
          th5: 'order total',
          th6: 'percentage earned',
          th7: 'reward amount',
          th8: 'balance',
        },
        csvBtn: 'Export .csv',
      },
      csv: {
        labels: {
          l1: 'INVOICE/MEMO #',
          l2: 'DATE',
          l3: 'SHOPIFY REWARD',
          l4: 'REFERRAL THRESHOLD',
          l5: 'ORDER TOTAL',
          l6: 'PERCENTAGE EARNED',
          l7: 'REWARD AMOUNT',
          l8: 'TYPE',
          l9: 'BALANCE',
        },
      },
    },
  },
  transactions: {
    header: {
      heading: 'Transaction History',
    },
    table: {
      heading: '',
      toolbar: {
        preview: {
          credit: 'Credit',
          balance: 'Balance',
        },
      },
      ths: {
        th1: 'transaction type',
        th2: 'details',
        th3: 'date created',
        th4: 'invoice/memo #',
        th5: 'sales order',
        th6: 'amount',
        th7: 'amount remaining',
        th8: 'status',
      },
      csvBtn: 'Export .csv',
    },
    csv: {
      labels: {
        l1: 'TRANSACTION TYPE',
        l2: 'DATE CREATED',
        l3: 'INVOICE/MEMO #',
        l4: 'SALES ORDER',
        l5: 'AMOUNT',
        l6: 'AMOUNT REMAINING',
        l7: 'STATUS',
      },
    },
    details: {
      header: {
        heading: 'Transaction Details',
      },
      preview: {
        transactionType: 'Transaction Type',
        transactionAmount: 'Transaction Amount',
        transactionDate: 'Transaction Date',
        invoiceMemo: 'Invoice/Memo #',
        salesOrder: 'Sales Order',
      },
      table: {
        ths: {
          th1: 'items',
          th2: 'description',
          th3: 'price',
        },
      },
    },
  },
  account: {
    firstTimeModal: {
      heading: 'Choose your preferred language',
      description: 'You can change your language selection at any time under your preferences.',
    },
    header: {
      heading: 'Account Setting',
    },
    settings: {
      fields: {
        name: 'Name',
        email: 'Email',
        password: 'Password',
        language: 'Language',
      },
      btns: {
        edit: 'edit',
        password: 'change password',
        save: 'save',
      },
    },
  },
  tooltipDateRange: {
    prefix: 'Date Range:',
    range: {
      all: 'All data',
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This week',
      lastWeek: 'Last week',
      lastMonth: 'Last month',
      thisQuarter: 'This quarter',
      lastQuarter: 'Last quarter',
      thisYear: 'This year',
      lastYear: 'Last Year',
      custom: 'Custom date range',
    },
  },
  pagination: {
    prev: 'Prev',
    next: 'Next',
  },
};
